import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useInfiniteQueryFlatted } from "@/shared/hooks/useInfiniteQueryFlatted.ts";
import { useSuspenseInfiniteQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useChallengeMembers } from "@/pages/challenges/api/challenge-members.api.ts";
import InfiniteScrollList, { checkFetchMore } from "@/components/base/InfiniteScrollList.tsx";
import UserCardLoading from "@/pages/challenges/components/UserCardLoading.tsx";
import { ChallengeMemberList } from "@/pages/challenges/SingleParticipants.tsx";
import ParticipantCard from "@/pages/challenges/components/ParticipantCard.tsx";
import Divider from "@/components/common/Divider.tsx";
import { ChallengeStatus } from "@/pages/challenges/types";
import { useChallengeDetail, useStaticPageDetail } from "@/pages/challenges/api/useChallengeDetail.ts";
import { useGetProfile } from "@/pages/profile/api";
import ChallengesSingleSlider from "@/pages/challenges/ChallengesSingleSlider.tsx";
import ExpandableText from "@/components/common/ExpandableText/ExpandableText.tsx";

const ChallengeAwardDetails = () => {
  const { t } = useTranslation();
  const { challengeId: slug } = useParams();
  const { data: profile } = useGetProfile();
  const { data: challengeData } = useSuspenseQuery(useChallengeDetail(slug));
  const { data: staticPageData } = useSuspenseQuery(useStaticPageDetail(slug));
  const queryResult = useSuspenseInfiniteQuery(
    useChallengeMembers(slug, undefined, true)
  );



  const winnerList = useInfiniteQueryFlatted(queryResult.data);
  return (
    <div className="text-white">
      <ChallengesSingleSlider
        medias={staticPageData?.medias}
      />
      <div className="container flex flex-col gap-2">
        <h1 className="mt-5 text-xl font-bold leading-130 text-white">
          {staticPageData.title}
        </h1>
        {challengeData.status === ChallengeStatus.COMPLETED ? (
          <ExpandableText text={staticPageData.content}/>
        ) : (
          <ExpandableText
            text={challengeData.description || t("no_description")}
            className="text-xs text-white font-normal leading-140 mb-4"
          />
        )}
      <InfiniteScrollList
        fetchNextPage={queryResult.fetchNextPage}
        canFetchMore={checkFetchMore(queryResult)}
        isFetchingNextPage={queryResult.isFetchingNextPage}
        placeholder={
          <div className="grid gap-3">
            {Array.from({ length: 5 }).map((_, idx) => (
              <UserCardLoading key={idx} />
            ))}
          </div>
        }
      >
        <div className="flex flex-col gap-3">
          <h2 className="text-lg font-bold leading-130 text-white">
              {t("gift_owners")}
          </h2>
          {challengeData.super_winner && (
            <>
              <ParticipantCard
                avatar={challengeData.super_winner.avatar}
                fullName={challengeData.super_winner.full_name}
                isMe={challengeData.super_winner.id === profile?.id}
                isPremium={challengeData.super_winner.is_premium}
                username={challengeData.super_winner.username}
                showSeperator={false}
                chance={challengeData.super_winner.opportunities}
                isCompleted
                gift={challengeData.super_award}
              />
              <Divider />
            </>
          )}
          <ChallengeMemberList
            members={winnerList}
            isCompleted={challengeData.status === ChallengeStatus.COMPLETED}
            showSeperator={false}
          />
        </div>
      </InfiniteScrollList>
      </div>
    </div>
  );
};

export default ChallengeAwardDetails;